<template>
<div id="twoRowStateSelector">
    <v-carousel
    hide-delimiters
    :next-icon="'〉'"
        :prev-icon="'〈'"
        height="auto"
    >
      <v-carousel-item>
            <div class="stateRow">
              <router-link to="/nation"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/USA.png" /></router-link>
               <router-link to="/state/al"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/AL.png" @click="selectState('01')" /></router-link>
<router-link to="/state/ak"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/AK.png" @click="selectState('02')" /></router-link>
<router-link to="/state/az"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/AZ.png"  @click="selectState('04')" /></router-link>
<router-link to="/state/ar"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/AR.png"  @click="selectState('05')" /></router-link>
<router-link to="/state/ca"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/CA.png" @click="selectState('06')" /></router-link>
<router-link to="/state/co"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/CO.png" @click="selectState('08')" /></router-link>

</div>

<div class="stateRow">
  <router-link to="/state/ct"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/CT.png" @click="selectState('09')" /></router-link>
  <router-link to="/state/dc"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/DC2.png" @click="selectState('11')" /></router-link>
<router-link to="/state/de"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/DE.png" @click="selectState('10')" /></router-link>

<router-link to="/state/fl"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/FL.png" @click="selectState('12')" /></router-link>
<router-link to="/state/ga"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/GA.png" @click="selectState('13')" /></router-link>
<router-link to="/state/hi"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/HI.png" @click="selectState('15')" /></router-link>
<router-link to="/state/id"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/ID.png" @click="selectState('16')" /></router-link> 

        

        
</div>
            
      </v-carousel-item>
      <v-carousel-item>
                <div class="stateRow">
                  <router-link to="/state/il"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/IL.png" @click="selectState('17')" /></router-link> 
                  <router-link to="/state/in"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/IN.png" @click="selectState('18')" /></router-link> 
                <router-link to="/state/ia"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/IA.png" @click="selectState('19')" /></router-link> 

        <router-link to="/state/ks"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/KS.png" @click="selectState('20')" /></router-link> 

        <router-link to="/state/ky"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/KY.png" @click="selectState('21')" /></router-link> 

        <router-link to="/state/la"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/LA.png" @click="selectState('22')" /></router-link> 

        <router-link to="/state/me"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/ME.png" @click="selectState('23')" /></router-link> 

         

        
                </div>
                <div class="stateRow">
                  <router-link to="/state/md"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MD.png" @click="selectState('24')" /></router-link>
                  <router-link to="/state/ma"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MA.png" @click="selectState('25')" /></router-link> 
                    <router-link to="/state/mi"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MI.png" @click="selectState('26')" /></router-link> 

        <router-link to="/state/mn"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MN.png" @click="selectState('27')" /></router-link> 

        <router-link to="/state/ms"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MS.png" @click="selectState('28')" /></router-link> 

        <router-link to="/state/mo"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MO.png" @click="selectState('29')" /></router-link> 

        <router-link to="/state/mt"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/MT.png" @click="selectState('30')" /></router-link> 

        

        

         
            </div>
      </v-carousel-item>
    
      <v-carousel-item>
          <div class="stateRow">
            <router-link to="/state/ne"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NE.png" @click="selectState('31')" /></router-link> 
            <router-link to="/state/nv"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NV.png" @click="selectState('32')" /></router-link>
            <router-link to="/state/nh"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NH.png" @click="selectState('33')" /></router-link>
          <router-link to="/state/nj"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NJ.png" @click="selectState('34')" /></router-link> 

        <router-link to="/state/nm"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NM.png" @click="selectState('35')" /></router-link> 

        <router-link to="/state/ny"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NY.png" @click="selectState('36')" /></router-link> 

        <router-link to="/state/nc"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/NC.png" @click="selectState('37')" /></router-link> 

        

        
          </div>
          <div class="stateRow">
            <router-link to="/state/nd"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/ND.png" @click="selectState('38')" /></router-link> 
            <router-link to="/state/oh"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/OH.png" @click="selectState('39')" /></router-link> 
<router-link to="/state/ok"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/OK.png" @click="selectState('40')" /></router-link> 

        <router-link to="/state/or"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/OR.png" @click="selectState('41')" /></router-link> 

        <router-link to="/state/pa"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/PA.png" @click="selectState('42')" /></router-link> 

        <router-link to="/state/pr"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/PR.png" @click="selectState('72')" /></router-link> 

        <router-link to="/state/ri"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/RI.png" @click="selectState('44')" /></router-link> 

        

         

        
</div>
      </v-carousel-item>

      <v-carousel-item>
          <div class="stateRow">
            <router-link to="/state/sc"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/SC.png" @click="selectState('45')" /></router-link> 
            <router-link to="/state/sd"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/SD.png" @click="selectState('46')" /></router-link>
            <router-link to="/state/tn"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/TN.png" @click="selectState('47')" /></router-link>
<router-link to="/state/tx"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/TX.png" @click="selectState('48')" /></router-link> 

        <router-link to="/state/ut"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/UT.png" @click="selectState('49')" /></router-link> 

        <router-link to="/state/vt"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/VT.png" @click="selectState('50')" /></router-link> 
 
        


    
          </div>
          <div class="stateRow">
            <router-link to="/state/va"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/VA.png" @click="selectState('51')" /></router-link> 

            <router-link to="/state/wa"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/WA.png" @click="selectState('53')" /></router-link>
 

        <router-link to="/state/wv"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/WV.png" @click="selectState('54')" /></router-link> 

        <router-link to="/state/wi"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/WI.png" @click="selectState('55')" /></router-link> 

        <router-link to="/state/wy"><img class="twoRowSelectorIcon selectorIcon" src="../assets/state-icons/WY.png" @click="selectState('56')" /></router-link>
</div>
      </v-carousel-item>
    </v-carousel>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    widthNum: {
      type: Number
    }
  },
  methods: {
        selectState(value) {
          this.$store.dispatch('selectState', value);
        },
  }
}
</script>